module.exports = __webpack_public_path__ + "static/globe-f1e28ccc5a562fd609c93cdbce763749.svg";